import { combineReducers } from "redux";
import { navbarReducers } from "./navbarReducres";
import { jobsReducer } from "./jobsReducers"
import { applicationsReducer } from "./applicationsReducers";

const reducers = combineReducers({
    sidebarReducres : navbarReducers,
    jobsReducer: jobsReducer,
    applicationsReducer: applicationsReducer
});

export default reducers;